import { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useQueryClient } from '@tanstack/react-query'
import { Button, showToast } from '@mercai/clever'
import { QUERIES_ADMIN, useBulkQuotation } from '@/services'

import { TableQuotation } from '@/pages/business/quotation-v2/list/components'

import { ModalBulkKam } from '../modal-bulk-kam'

import { QuotationProps } from './quotation.type'

export const Quotation = ({
  buyerProfileUuid,
  isLoadingKams = false,
  kams = [],
  setSearchKams,
}: QuotationProps) => {
  const { t } = useTranslation('screenProfileShow')

  const queryClient = useQueryClient()

  const [isOpenModalBulkKam, setisOpenModalBulkKam] = useState(false)

  const [quotationChecked, setQuotationChecked] = useState<string[]>([])

  const [selectedKam, setSelectedKam] = useState<{
    label: string
    value: string
  }>()

  const kamsOptions = useMemo(() => {
    const kamsWithName = kams?.filter((user) => user?.name) || []

    const mappedKams = kamsWithName.map((user) => ({
      label: user.name,
      value: `${user.id}`,
    }))

    const options = [...mappedKams]

    return options.sort((a, b) => a.label.localeCompare(b.label))
  }, [kams])

  const { mutateAsync: bulkQuotationKam, isPending: isLoadingBulk } =
    useBulkQuotation()

  const onBulkQuotationKAM = async () => {
    const response = await bulkQuotationKam({
      data: {
        keyAccountManagerId: selectedKam?.value
          ? +selectedKam?.value
          : undefined,
      } as Partial<QuotationProps>,
      items: quotationChecked,
    })

    if (!response.success) {
      showToast({
        variant: 'error',
        title: t('bulkKAMError'),
      })
      return
    }

    setQuotationChecked([])
    setisOpenModalBulkKam(false)
    setSelectedKam(undefined)

    showToast({
      variant: 'success',
      title: t('bulkKAMSuccess'),
    })

    queryClient.invalidateQueries({
      queryKey: [QUERIES_ADMIN.QUOTATION.module],
    })
  }

  const BulkQuotationKAM = () => {
    return (
      <Button
        variant="primary"
        onClick={() => setisOpenModalBulkKam(true)}
        disabled={quotationChecked.length === 0}
      >
        {t('bulkKAMButton')}
      </Button>
    )
  }

  const onCloseModalBulkKam = () => {
    setisOpenModalBulkKam(false)
    setSelectedKam(undefined)
  }

  return (
    <>
      <TableQuotation
        buyerProfile={buyerProfileUuid}
        hasAddButton
        setCheckedRows={setQuotationChecked}
        checkedRows={quotationChecked}
        {...(quotationChecked.length > 0 && {
          headerComponents: <BulkQuotationKAM />,
        })}
      />

      {isOpenModalBulkKam && (
        <ModalBulkKam
          onClose={onCloseModalBulkKam}
          isOpen={isOpenModalBulkKam}
          kams={kamsOptions}
          isLoadingKams={isLoadingKams}
          setSearchKams={setSearchKams}
          selectedKam={selectedKam}
          setSelectedKam={setSelectedKam}
          onSubmit={onBulkQuotationKAM}
          isLoadingSubmit={isLoadingBulk}
        />
      )}
    </>
  )
}
